export default __webpack_public_path__ + "static/screen-4-afc33dc33d5c3f2be8faf0ceff39359f.png";